import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Plagiarism from './pages/Plagiarism';
import IntellectualProperty from './pages/IntellectualProperty';
import CasosPlaPi from './pages/CasosPlaPi'; // Importación nueva
import GamesPlagiarism from './pages/GamesPlagiarism';
import GamesIntellectualProperty from './pages/GamesIntellectualProperty';
import SummaryPlagiarism from './pages/SummaryPlagiarism';
import SummaryIntellectualProperty from './pages/SummaryIntellectualProperty';
import AskPlaPi from './pages/AskPlaPi';
import References from './pages/References';
import ThemeProvider from './context/ThemeContext';

const LoadingScreen = () => (
  <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 dark:from-gray-900 dark:via-blue-900 dark:to-purple-900 flex items-center justify-center">
    <div className="text-center">
      <div className="w-8 h-8 border-2 border-indigo-200 border-t-indigo-600 rounded-full animate-spin mx-auto mb-2"></div>
      <h2 className="text-base font-medium text-gray-700 dark:text-gray-300">Cargando PlaPi...</h2>
    </div>
  </div>
);

const RouteWrapper = ({ children }) => {
  const location = useLocation();
  return (
    <motion.div key={location.pathname} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.15 }}>
      {children}
    </motion.div>
  );
};

function AppContent() {
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 100);
    return () => clearTimeout(timer);
  }, []);

  if (isLoading) return <LoadingScreen />;

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 dark:from-gray-900 dark:via-blue-900 dark:to-purple-900 transition-colors duration-200">
      <Header />
      <main className="flex-1 pt-16">
        <AnimatePresence mode="wait">
          <Routes>
            <Route path="/" element={<RouteWrapper><Home /></RouteWrapper>} />
            <Route path="/conceptualizacion/plagio" element={<RouteWrapper><Plagiarism /></RouteWrapper>} />
            <Route path="/conceptualizacion/propiedad-intelectual" element={<RouteWrapper><IntellectualProperty /></RouteWrapper>} />
            {/* NUEVA RUTA CASOS PLAPI */}
            <Route path="/intro/casos-plapi" element={<RouteWrapper><CasosPlaPi /></RouteWrapper>} />
            <Route path="/juegos/plagio" element={<RouteWrapper><GamesPlagiarism /></RouteWrapper>} />
            <Route path="/juegos/propiedad-intelectual" element={<RouteWrapper><GamesIntellectualProperty /></RouteWrapper>} />
            <Route path="/resumen/plagio" element={<RouteWrapper><SummaryPlagiarism /></RouteWrapper>} />
            <Route path="/resumen/propiedad-intelectual" element={<RouteWrapper><SummaryIntellectualProperty /></RouteWrapper>} />
            <Route path="/preguntale-a-plapi" element={<RouteWrapper><AskPlaPi /></RouteWrapper>} />
            <Route path="/referencias" element={<RouteWrapper><References /></RouteWrapper>} />
          </Routes>
        </AnimatePresence>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <Router>
        <AppContent />
      </Router>
    </ThemeProvider>
  );
}

export default App;